publishingApp.controller('adminController', ['$scope', '$rootScope', '$state', 'dbData', '$cookies', '$log', function ($scope, $rootScope, $state, dbData, $cookies, $log) {
    if(!$rootScope.userCan($rootScope.user.permissions, ['validation-rule-show', 'validation-rule-edit'])){
        // Redirect to home when the user has no permission to be here
        $state.go('index');
    }

    $scope.notifications = [];
    var VALIDATION_RULES_API_URL = 'validation-rules';
    var validationRulesResponse = null;
    var currentSelectedEntity = null;
    var container = document.getElementById("jsoneditor");
    var editor = new JSONEditor(container);
    var dropdownElement = document.getElementById('validationEntitySelect');
    dropdownElement.onchange = function () {
        $scope.setJSON();
    }

    $scope.getValidationRules = function () {
        dbData.get(VALIDATION_RULES_API_URL)
            .then(function (result) {
                    validationRulesResponse = result.data;
                    dropdownElement.options.length = 0;
                    for (var i = 0; i < validationRulesResponse.length; i++) {
                        var validationRulesRow = validationRulesResponse[i];
                        dropdownElement.options.add(new Option(validationRulesRow.entity, validationRulesRow.id))
                    }
                    $scope.setJSON();
                }
            );
    };
    $scope.setJSON = function () {
        currentSelectedEntity = validationRulesResponse.filter(
            function (validationRulesResponseItem) {
                return validationRulesResponseItem.id === +dropdownElement.value;
            }
        );
        editor.set(JSON.parse(currentSelectedEntity[0].rules));
    }

    $scope.getValidationRules();

    $scope.updateValidationRules = function () {
        var updateData = editor.get();
        dbData.post(VALIDATION_RULES_API_URL + '/' + +currentSelectedEntity[0].id,
            {
                rules: JSON.stringify(updateData)
            }).then(function (response) {
            alert('Validation Rules for ' + currentSelectedEntity[0].entity + 'were updated');
        }, function (err) {
            alert('Error Updating Validation Rules for ' + currentSelectedEntity[0].entity);
        });
    }
}]);